module.exports = __webpack_public_path__ + "static/media/chain-echart-1.fcb17fb7.png";